<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['NOME', 'MATRÍCULA', 'CPF', 'EMAIL CORPORATIVO']"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.pessoa.nome ? obj.pessoa.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.matricula ? obj.matricula : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.pessoa.document ? formatDocument(obj.pessoa.document) : ''"/>
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.pessoa.emailCorporativo ? obj.pessoa.emailCorporativo : ''" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button>
      </div>
    </div>
        <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import EmployeeRepository from '@/shared/http/repositories/configurations/employee.js'
import SidebarSearch from '@/views/private/configurations/person/components/search/SidebarOrganizacaoPessoa.vue'

export default {
  name: 'PaList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  components: {
    SidebarSearch
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.close()
      if (this.filters) {
        EmployeeRepository.Search(this.createRequestParam(), this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((res) => {
            this.onResultGrid(res)
          })
          .catch(this.onException)
      } else {
        EmployeeRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    createRequestParam () {
      let listParam = []
      if (this.filters.nome) {
        if (/^[A-Za-z\s]*$/.test(this.filters.nome)) {
          listParam.push('nome=' + this.filters.nome.toString())
        } else {
          listParam.push('matricula=' + this.filters.nome.toString().replace(/[^\d]+/g, ''))
          listParam.push('document=' + this.filters.nome.toString().replace(/[^\d]+/g, ''))
        }
      }
      return listParam.join('&')
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    formatDocument (doc) {
      return Tools.formatCpfCnpj(doc, Tools.checkDocumentType(doc))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/employee/components/list/employeeList.vue